import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import MaterialAppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import SvgIcon from '../../icons/SvgIcon';
import { Colors, Metrics } from '../../themes';
import LanguageSelector from './LanguageSelector';
import { withRouter } from 'react-router-dom';
import { navItems as routesData } from '../../Routes';
import clsx from 'clsx';

const StyledToolbar = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
`;

const useStyles = makeStyles((theme) => ({
  appBar: {
    marginLeft: Metrics.drawerWidth,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    '& div.MuiToolbar-root': {
      height: 64,
      background: Colors.black,
    },
  },
  controllersAppBar: {
    marginLeft: Metrics.drawerWidth,
    [theme.breakpoints.up(Metrics.breakpoints.lg + Metrics.controllersAddToLg)]: {
      display: 'none',
    },
    '& div.MuiToolbar-root': {
      height: 64,
      background: Colors.black,
    },
  },
}));

const AppBar = (props) => {
  const { handleDrawerToggle } = props;
  const classes = useStyles();
  const currentRoute = routesData.find((route) => route.route === props.location.pathname);
  const isControllers = currentRoute?.route === '/controllers';
  return (
    <MaterialAppBar position="fixed" className={clsx(isControllers ? classes.controllersAppBar : classes.appBar)}>
      <StyledToolbar>
        <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle}>
          <MenuIcon
            style={{
              fontSize: '32px',
              color: Colors.lightGreyOnBlack,
            }}
          />
        </IconButton>
        <SvgIcon icon={'Digiovi'} width={111.58} color={Colors.white} />
        <LanguageSelector />
      </StyledToolbar>
    </MaterialAppBar>
  );
};

export default withRouter(AppBar);
